import { isObject } from 'lodash';
import { NONE, SUBSCRIBE_DEFINITION_LIST } from 'constants/Integrations';

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
};

export const buildAccountsInfoData = (date) => {
    const accountsInfo = {};

    date.forEach((item) => {
        if (item[3] && isJsonString(item[3])) {
            accountsInfo[item[0]] = JSON.parse(item[3]);
        }
    });

    return accountsInfo;
};

/**
 * Builds a UI-ready integrations list from the raw integrations object.
 *
 * @param {Object<string, Object>} integrations - An object where each key is an integration UUID and the value is the integration data.
 * @returns {Object<string, Object>|undefined} - A mapped object of integration metadata, keyed by UUID, or `undefined` if input is not an object.
 *
 * Each returned integration object contains:
 * - uuid: string
 * - authType: string
 * - authExplanation: string | undefined
 * - icon: string | undefined
 * - title: string | undefined
 * - name: string | undefined
 * - category: string | undefined
 * - description: string | undefined
 * - hasCallBack: boolean
 */
export function buildUiIntegrationsList(integrations) {
    if (!isObject(integrations)) {
        return;
    }

    return Object.entries(integrations).reduce((acc, [uuid, integration]) => {
        const { authentication, category, description, friendlyName, imageSource } =
            integration?.meta?.nucal_parject_definition?.list || {};
        const subscribe_definition_length = integration?.meta?.array_size?.[SUBSCRIBE_DEFINITION_LIST] || 0;

        acc[uuid] = {
            uuid,
            authType: authentication === null ? NONE : authentication?.type,
            authExplanation: authentication?.explanation,
            icon: imageSource,
            title: friendlyName,
            name: integration.name,
            category: category,
            description: description,
            hasCallBack: subscribe_definition_length > 0,
        };

        return acc;
    }, {});
}
